// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/transponder-operation.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/transponder-operation/transponder-operation.js';

mount([g0]);
